import { render, staticRenderFns } from "./resultComp.vue?vue&type=template&id=63dfe21f&scoped=true&"
import script from "./resultComp.vue?vue&type=script&lang=ts&"
export * from "./resultComp.vue?vue&type=script&lang=ts&"
import style0 from "./resultComp.vue?vue&type=style&index=0&id=63dfe21f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfe21f",
  null
  
)

export default component.exports